import React from "react";
import LoaderImage from "../../assets/img/loader.gif";

type BaseSpinnerProp = {
  spinnerText: string;
  styles: string;
};
const Spinner: React.FC<BaseSpinnerProp> = ({ spinnerText, styles = "" }) => {
  return (
    <div
      className={`${styles} flex flex-col h-[50vh] items-center justify-center items-center`}
    >
      {/*<ProgressSpinner style={{ width: '50px', height: '50px' }} />*/}
      <img
        src={LoaderImage}
        alt="loader"
        width={170}
        height={70}
        style={{ height: "auto" }}
      />
      <span className="text-center">{spinnerText || "Please wait..."}</span>
    </div>
  );
};

export default Spinner;
